import React from 'react'
import { Col, Row } from 'reactstrap'

import Logo from '../../Logo'

const FooterLogo = () => {
  return (
    <Row className="justify-content-center py-5">
      <Col md={3}>
        <div className="logoWrap pb-2">
          <Logo mode="dark" />
        </div>
      </Col>
    </Row>
  )
}
export default FooterLogo
